import LoginAsCompanyCEO from "../components/master-staff/LoginCompany";

const CompanyLoginAsCEOPage = () => {
  return (
    <>
      <LoginAsCompanyCEO />
    </>
  );
};
export default CompanyLoginAsCEOPage;
